async function getLayer(layer) {
	let response = await fetch(layer.url);
	let json = await response.json();
	return json;
}

export async function makeStyle(layers, glyphs, sprite) {
	let mapStyle = {
		version: 8,
		id: 'basemaps',
		name: 'basemaps',
		glyphs: glyphs,
		sprite: sprite,
		sources: {},
		layers: []
	};
	let dummyLayers = ['base','middle'];
	let mapLayers = {};
	
	for (const layer of layers) {
		let data = await getLayer(layer);
		let sources = Object.keys(data.sources);
		sources.forEach(s => {
			if (!mapStyle.sources[s]) {
				mapStyle.sources[s] = data.sources[s];
			}
		});
		mapLayers[layer.id] = [];
		data.layers.forEach(l => {
			l.id = `${layer.id}_${l.id}`;
			mapLayers[layer.id].push(l);
		});
	}
	
	dummyLayers.forEach(id => {
		mapStyle.layers.push({
			"id": id,
			"type": "background",
			"paint": {
        "background-opacity": 0
      }
		});
	});
	
	return {
		style: mapStyle,
		layers: mapLayers
	}
}

export function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}